import { render, staticRenderFns } from "./ATNOFSPage.vue?vue&type=template&id=3b855496&scoped=true&"
import script from "./ATNOFSPage.vue?vue&type=script&lang=js&"
export * from "./ATNOFSPage.vue?vue&type=script&lang=js&"
import style0 from "./ATNOFSPage.vue?vue&type=style&index=0&id=3b855496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b855496",
  null
  
)

export default component.exports